import { Box, ButtonProps, Flex } from '@chakra-ui/react'

export type PillSelectOption = {
  label: string
  value: string
}

export type PillSelectProps<Options extends PillSelectOption[]> =
  | {
      isMultiSelect: true
      onChange: (value: Options[number]['value'][]) => void
      selected: Options[number]['value'][]
    }
  | {
      isMultiSelect?: false
      onChange: (value: Options[number]['value']) => void
      selected: Options[number]['value']
    }

export const PillSelect = <Options extends PillSelectOption[]>({
  isMultiSelect,
  options,
  selected,
  onChange,
}: { options: Options } & PillSelectProps<Options>) => (
  <Flex gap="8px">
    {options.map(option => (
      <Pill
        key={option.value}
        role="option"
        onClick={() =>
          isMultiSelect
            ? onChange(
                selected.includes(option.value)
                  ? selected.filter(selected => selected !== option.value)
                  : [...selected, option.value],
              )
            : onChange(option.value)
        }
        isSelected={selected.includes(option.value)}
        {...option}
      >
        {option.label ?? option.value}
      </Pill>
    ))}
  </Flex>
)

export interface PillProps extends ButtonProps {
  isSelected?: boolean
}

export const Pill = ({ isSelected, ...props }: PillProps) => {
  return (
    <Box
      as="button"
      rounded="full"
      padding="4px 8px"
      fontSize="10px"
      fontWeight="600"
      {...(isSelected
        ? {
            backgroundColor: 'presets.turquoise.100',
            color: 'presets.neutral.0',
            _hover: {},
          }
        : {
            backgroundColor: 'presets.neutral.10',
            color: 'presets.turquoise.100',
          })}
      {...props}
    />
  )
}
